import script from "./RegPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RegPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__